var map = {
  "./cs.json": [
    "VHU",
    [
      "r6w"
    ]
  ],
  "./en.json": [
    "kU",
    [
      "ic"
    ]
  ],
  "./pl.json": [
    "nu7",
    [
      "t6"
    ]
  ],
  "./ru.json": [
    "SMc",
    [
      "ksy"
    ]
  ],
  "./tr.json": [
    "KT",
    [
      "sn"
    ]
  ],
  "./ja.json": [
    "Mmy",
    [
      "q3"
    ]
  ],
  "./zh.json": [
    "Yk",
    [
      "mr"
    ]
  ],
  "./pt-br.json": [
    "aYd",
    [
      "08"
    ]
  ],
  "./de.json": [
    "Xy",
    [
      "paz"
    ]
  ],
  "./es.json": [
    "j4g",
    [
      "df"
    ]
  ],
  "./fr.json": [
    "jrh",
    [
      "tq"
    ]
  ],
  "./it.json": [
    "mQF",
    [
      "4a"
    ]
  ],
  "./ko.json": [
    "Fk",
    [
      "fq"
    ]
  ],
  "./pt.json": [
    "ngH",
    [
      "ph7"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "AF";
module.exports = __rspack_async_context;
